import { render, staticRenderFns } from "./UserQuiz.vue?vue&type=template&id=158db459&scoped=true"
import script from "./UserQuiz.vue?vue&type=script&lang=js"
export * from "./UserQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158db459",
  null
  
)

export default component.exports